import { render, staticRenderFns } from "./systemDetailNotifyPop.vue?vue&type=template&id=57bc0adc&scoped=true"
import script from "./systemDetailNotifyPop.vue?vue&type=script&setup=true&lang=js"
export * from "./systemDetailNotifyPop.vue?vue&type=script&setup=true&lang=js"
import style0 from "./systemDetailNotifyPop.vue?vue&type=style&index=0&id=57bc0adc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc0adc",
  null
  
)

export default component.exports